import { useCallback } from "react";
import { IShift } from "types/schedules";

const ONE_HOUR_IN_MILLISECONDS = 60 * 60 * 1000;

export const useShiftTotalHoursHandler = () => {
  return useCallback((shift: IShift) => {
    return (
      (shift.endTime.getTime() - shift.startTime.getTime()) /
      ONE_HOUR_IN_MILLISECONDS
    );
  }, []);
};
